module.exports = __webpack_public_path__ + "img/3. BLONDE MANNEQUIN HEAD.jpg";